<script>
import { layoutComputed } from "@/state/helpers";
import { SimpleBar } from "simplebar-vue3";
import axios from "axios";

export default {
  components: {
    SimpleBar,
  },

  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      menu: JSON.parse(localStorage.getItem("menus")) || [],
    };
  },

  computed: {
    ...layoutComputed,
    layoutType() {
      return this.$store?.state?.layout?.layoutType || {};
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    // Fetch menus (you can comment this out if you only want to trust localStorage)
    this.GetMenu();
  },

  methods: {
    async GetMenu() {
      try {
        axios.defaults.headers.common["authorization"] =
          "Bearer " + localStorage.getItem("jwt");

        const response = await axios.get(
          process.env.VUE_APP_API_BASEURL + "menu/my"
        );

        if (response?.data) {
          this.menu = response.data;
          localStorage.setItem("menus", JSON.stringify(this.menu));
        } else {
          this.menu = [];
        }
      } catch (error) {
        console.error("Failed to load menus:", error);
        // Fallback to localStorage
        this.menu = JSON.parse(localStorage.getItem("menus")) || [];
      }
    },

    onRoutechange(route) {
      this.initActiveMenu(route.path);
    },

    initActiveMenu(path) {
      setTimeout(() => {
        const nav = document.querySelector("#navbar-nav");
        if (!nav) return;

        // Reset previous active states
        nav.querySelectorAll(".active").forEach(el => el.classList.remove("active"));
        nav.querySelectorAll(".collapse.show").forEach(el => el.classList.remove("show"));
        nav.querySelectorAll('[aria-expanded="true"]').forEach(el =>
          el.setAttribute("aria-expanded", "false")
        );

        // Find matching link
        const fullPath = process.env.VUE_APP_BASE_URL + path;
        const link = nav.querySelector(`a[href="${fullPath}"]`);

        if (link) {
          link.classList.add("active");

          // Open parent collapses (pure DOM – no Bootstrap JS needed)
          let current = link.closest(".collapse.menu-dropdown");
          while (current) {
            current.classList.add("show");
            const toggle = current.previousElementSibling;
            if (toggle && toggle.hasAttribute("data-bs-toggle")) {
              toggle.classList.add("active");
              toggle.setAttribute("aria-expanded", "true");
            }
            current = current.parentElement?.closest(".collapse.menu-dropdown");
          }
        }
      }, 100);
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'twocolumn'">
      <SimpleBar class="navbar-nav" id="navbar-nav">
        <!-- two column layout content if needed -->
      </SimpleBar>
    </template>

    <template v-else>
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="menu-title">
          <!-- <span data-key="t-menu">Menu</span> -->
        </li>

        <li
          v-for="(item, index) in menu"
          :key="index"
          class="nav-item"
        >
          <!-- Item with submenu -->
          <template v-if="item.menu && item.menu.length > 0">
            <a
              class="nav-link menu-link"
              :href="item.tab_link"
              data-bs-toggle="collapse"
              :data-bs-target="'#menu-' + item.id"
              aria-expanded="false"
              :aria-controls="'menu-' + item.id"
            >
              <i :class="item.tab_icon"></i>
              <span>{{ item.tab_name || item.name }}</span>
            </a>

            <div
              class="collapse menu-dropdown"
              :id="'menu-' + item.id"
            >
              <ul class="nav nav-sm flex-column">
                <li
                  v-for="(sub, subIndex) in item.menu"
                  :key="subIndex"
                  class="nav-item"
                >
                  <router-link
                    :to="sub.tab_link"
                    class="nav-link"
                    :class="{ active: $route.path === sub.tab_link }"
                  >
                    {{ sub.tab_name || sub.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </template>

          <!-- Item without submenu -->
          <template v-else>
            <router-link
              :to="item.tab_link"
              class="nav-link menu-link"
              :class="{ active: $route.path === item.tab_link }"
            >
              <i :class="item.tab_icon"></i>
              <span>{{ item.tab_name || item.name }}</span>
            </router-link>
          </template>
        </li>
      </ul>
    </template>
  </div>
</template>

<style scoped>
.nav-link.active {
  background-color: rgba(67, 97, 238, 0.1);
  color: #4361ee !important;
  font-weight: 500;
}
</style>